import { Typography, Button } from '@mui/material';
import { TFunction } from 'i18next';
import React from 'react';
import { Actions, State } from '../hooks/useChannelSetup';
import { useValidation } from '../useValidation';

const RenderButtonSection = ({
  mode,
  integrationType,
  state,
  actions,
  t,
  classes,
}: {
  mode: string;
  integrationType: string;
  state: State;
  actions: Actions;
  t: TFunction;
  classes: Record<string, string>;
}) => {
  const { disabled } = useValidation({ ...state, mode, integrationType } as any);
  return (
    <div className={`${classes.descriptionSection} ${classes.magiclineInnerPadding}`}>
      <Typography variant="body2" className={classes.magiclineDescription}>
        {t('magicline.setup.description')}
      </Typography>
      <Button
        disabled={disabled}
        onClick={actions.handleSave}
        variant="contained"
        size="medium"
        color="primary"
      >
        {t('app.save')}
      </Button>
    </div>
  );
};

export default RenderButtonSection;
